const indexItems = [
  { id: 1, title: '明星恋情', icon: 'ri-heart-line', count: '326条', hot: true },
  { id: 2, title: '综艺吃瓜', icon: 'ri-tv-line', count: '258条', hot: true },
  { id: 3, title: '影视动态', icon: 'ri-film-line', count: '192条', hot: false },
  { id: 4, title: '网红翻车', icon: 'ri-alert-line', count: '415条', hot: true },
  { id: 5, title: '商业八卦', icon: 'ri-briefcase-line', count: '147条', hot: false },
  { id: 6, title: '音乐吃瓜', icon: 'ri-music-line', count: '183条', hot: false },
  { id: 7, title: '时尚圈', icon: 'ri-shirt-line', count: '98条', hot: false },
  { id: 8, title: '体育八卦', icon: 'ri-basketball-line', count: '221条', hot: true },
  { id: 9, title: '社会热点', icon: 'ri-fire-line', count: '503条', hot: true },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按分类浏览你最感兴趣的吃瓜内容和黑料视频
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-center gap-4 transition-all hover:-translate-y-0.5 hover:border-accent-300 cursor-pointer relative overflow-hidden"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  {item.hot && (
                    <span className="text-[10px] bg-primary-500 text-background-50 px-1.5 py-0.5 rounded-full font-medium flex-shrink-0">
                      HOT
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count} 内容</p>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}